import { Box, Stack, Typography } from '@mui/material'

import { TOutreach } from '~/features/campaigns/models'

type TOutreachCallScriptPreviewPayload = {
  outreach: TOutreach
}

export default function OutreachCallScriptPreview({
  outreach,
}: TOutreachCallScriptPreviewPayload) {
  return (
    <Stack>
      {outreach.voicemailScript && (
        <Box>
          <Typography variant="body2">Voicemail Script:</Typography>
          <Typography variant="body2">{outreach.voicemailScript}</Typography>
        </Box>
      )}
    </Stack>
  )
}
